export enum FeatureFlagKeysEnum {
  NATIVE_UPDATE_REQUIRED = 'native-update-required',
  MANUAL_REGISTRATION_ENTRY_POINT = 'manual-registration-entry-point',
}
